import { render, staticRenderFns } from "./PageAddress.vue?vue&type=template&id=4b12786a"
import script from "./PageAddress.vue?vue&type=script&lang=js"
export * from "./PageAddress.vue?vue&type=script&lang=js"
import style0 from "./PageAddress.vue?vue&type=style&index=0&id=4b12786a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports